import Form from "../components/Form";

export default class PageDefault {
  constructor() {
    this.data = null;
  }

  init(data) {
    this.data = data;

    const forms = document.querySelectorAll(".wpcf7");
    forms?.forEach(form => {
      const form_obj = new Form(this.data, form);
      form_obj.init();
    });
  }
}